export default [
  { name: 'Title', prop: 'title', type: 'text' },
  { name: 'Description', prop: 'description', type: 'wysiwyg' },
  {
    name: 'Facilitator',
    prop: 'facilitator_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    displayProp: 'name',
    query: {
      filters: {
        roles_json_contains: 'facilitator'
      }
    }
  }
]
